export function formatNumber(value: number = 0): string {
  return new Intl.NumberFormat('da-DK').format(value)
}

export function formatCurrency(value?: number): string {
  if (typeof value !== 'number' || value == null) return ''

  return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(value)
}

export function isDefined(values: any[]): void {
  values.forEach(value => {
    if (value === undefined || value === null) throw 'Something is not defined!'
  })
}

export type NullOrUndefined = null | undefined